import { mixpanel } from '@hive/track';
import { OnEvent, Service } from '@toeverything/infra';

import { ApplicationFocused } from '../../lifecycle';
import { UserQuota } from '../entities/user-quota';
import { AccountChanged } from '../events/account-changed';

@OnEvent(AccountChanged, e => e.onAccountChanged)
@OnEvent(ApplicationFocused, e => e.onApplicationFocused)
export class UserQuotaService extends Service {
  constructor() {
    super();

    this.quota.quota$
      .map(q => q?.humanReadable.name)
      .distinctUntilChanged()
      .subscribe(quota => {
        mixpanel.people.set({
          quota,
        });
      });
  }

  quota = this.framework.createEntity(UserQuota);

  private onAccountChanged() {
    this.quota.revalidate();
  }

  private onApplicationFocused() {
    // Revalidate quota when window gains focus (e.g., after returning from Stripe checkout)
    this.quota.revalidate();
  }
}
